import { render } from "./FreeSerach.vue?vue&type=template&id=52ef01ce"
import script from "./FreeSerach.vue?vue&type=script&lang=js"
export * from "./FreeSerach.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__